import { jsx as _jsx } from "react/jsx-runtime";
import { Send } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { TelegramDestinationsPage } from './routes/telegram-page.js';
const { Provider: TelegramModulePermsProvider, usePerms: useTelegramPerms } = createModulePerms({ canManage: false, canRerenderCards: false });
export { TelegramModulePermsProvider };
function TelegramPageRoute() {
    const { canManage, canRerenderCards } = useTelegramPerms();
    return _jsx(TelegramDestinationsPage, { canManage: canManage, canRerenderCards: canRerenderCards });
}
export const telegramModule = {
    id: 'telegram',
    label: 'Telegram',
    icon: Send,
    permission: 'telegram_destinations.list',
    workspace: 'system',
    order: 35,
    description: 'Чаты Telegram, в которые бот публикует карточки обращений.',
    showInNav: true,
    routes: [{ path: '/', component: TelegramPageRoute }],
};
export { TelegramDestinationsPage } from './routes/telegram-page.js';
export { setTelegramApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map